import React from "react"

export default class LoadingIndicator extends React.Component {
  render() {
    return (
      <div
        className="progress"
        style={{
          width: "75%",
          marginTop: "50px",
          marginBottom: "50px",
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <div
          className="progress-bar progress-bar-striped" // progress-bar-animated removed to see if that impacts memory usage
          role="progressbar"
          style={{ width: "100%", backgroundColor: "var(--lanzalake-blue-mid)" }}
        />
      </div>
    )
  }
}
